import {useContext, useEffect, useState} from 'react';
import { useNavigate, useParams, Link } from "react-router-dom";
import { InputContext } from '../contexts/InputContext';
import BotonVolver from '../components/BotonVolver';
import resourcesServices from '../services/resourcesServices';
import { errorMessage } from '../errorHandler';
import TextControl from '../components/customizedInputs/TextControl';
import { pdf } from '@react-pdf/renderer';
import RptDeclaracionJuradaObligado from '../components/reportes/RptDeclaracionJuradaObligado';

const DeclaracionJuradaForm = () => {
  let { id } = useParams();
  const [usuario, setUsuario] = useState();
  const [saving, setSaving] = useState(false);
  const [step, setStep] = useState(3);

  const navigate = useNavigate();
  const [authInformation] = useContext(InputContext)
  const [renderHTML, setRenderHTML] = useState(false)
  const [valido, setValido] = useState(false);
  const [adjunto, setAdjunto] = useState(null);
  const [resource, setResource] = useState({});

  useEffect(() => {
    if(authInformation.autenticado === false){
      navigate(`/ingreso`);
    } else if( authInformation.autenticado === true){
      setRenderHTML(true)
      fetchDeclaracionJurada()
      fetchUsuario(authInformation.usuario_id, authInformation.rol)
    } else {
      setRenderHTML(false)
    }
  }, [authInformation]);


  const fetchDeclaracionJurada = async () => {
    try {
      setSaving(true)
      const data = await resourcesServices.nuevoResource('declaraciones_juradas');

      setResource(data);
      setSaving(false)
    } catch (error) {
      setSaving(false)
      errorMessage(error)
    }
  };

  const fetchUsuario = async (id, rol) => {
    try {
      setSaving(true)
      const url_param = rol ? `${id}/${rol}/porRol` : `${id}`
      const data = await resourcesServices.obtenerResourcePorId('usuarios', url_param);

      setUsuario(data);
      setSaving(false)

    } catch (error) {
      setSaving(false)
      errorMessage(error)
    }
  };

  const handleFileChange = (e) => {
    const { name, files } = e.target;
    setAdjunto(files[0])
  };

  const guardarDeclaracionJurada = async () => {
    try {
      setSaving(true)

      const attributeName = 'declaracion_jurada'
      const formData =  new FormData();
      for(const [key, value] of Object.entries(resource)){
        if(value){
          formData.append(`${attributeName}[${key}]`, value || '')
        }
      }

      if(adjunto){
        formData.append(`${attributeName}[adjunto]`, adjunto)
      }

      await resourcesServices.crearResource('declaraciones_juradas', formData);

      setSaving(false)
      navigate(`/`);

    } catch (error) {
      setSaving(false)
      errorMessage(error)
    }
  };

  const generarDDJJObligado = async () => {
      const blob = await pdf( <RptDeclaracionJuradaObligado resource={usuario} preferencias={usuario.preferencias_usuario} declaracionJurada={resource}  /> ).toBlob();
      const url = URL.createObjectURL(blob);
      window.open(url, '_blank'); // Abre el PDF en una nueva pestaña
  };


  const validarCampos = async () => {
    try {
      setSaving(true)
      setValido(false)

      const data = await resourcesServices.crearResource('declaraciones_juradas/validarContenido', {declaracion_jurada: resource}, false);

      setSaving(false)
      setValido(true)
      alert("Datos Validos")

    } catch (error) {
      setValido(false)
      setSaving(false)
      errorMessage(error)
    }
  };


  const handleFormSubmit = (e) => {
    e.preventDefault()
    if(window.confirm('Está seguro que quiere crear una nueva declaracion jurada?')) {
      guardarDeclaracionJurada()
    }
  }

  const handleInput = (e) => {
    let { name, value, files, type } = e.target;

    setResource({...resource,
      [name]: value
    })
  }

  return (
    <div>
      {renderHTML && (
        <>
        <h1>Nueva Declaración Jurada <BotonVolver /></h1>

        <form id="carouselExample" className='carousel slide' onSubmit={handleFormSubmit}>
          <div className='carousel-inner p-3'>
            <div className='carousel-item active'>
              <div className="row mt-3">
                <div className="col-12">
                  <div className="card mb-5">
                    <div className="card-body">
                      <h5 className="card-title">Información personal</h5>
                        <div className="row mt-3">
                          <div className="col-6">
                            <TextControl
                              value={resource.cargo}
                              name={'cargo'}
                              handleInput={handleInput}
                              />
                          </div>
                          <div className="col-6">
                            <TextControl
                              value={resource.organismo}
                              name={'organismo'}
                              handleInput={handleInput}
                              />
                          </div>

                          <div className="col-6">
                            <h5>Alta norma legal</h5>
                            <TextControl
                              value={resource.f_cargo_desde}
                              name={'f_cargo_desde'}
                              label='Fecha'
                              type='date'
                              handleInput={handleInput}
                              />
                            <TextControl
                              value={resource.numero_alta_norma_legal}
                              name={'numero_alta_norma_legal'}
                              label='Número de norma legal'
                              handleInput={handleInput}
                              />
                          </div>
                          <div className="col-6">
                            <h5>Baja norma legal</h5>
                            <TextControl
                              value={resource.f_cargo_hasta}
                              name={'f_cargo_hasta'}
                              label='Fecha'
                              type='date'
                              handleInput={handleInput}
                              />
                            <TextControl
                              value={resource.numero_baja_norma_legal}
                              name={'numero_baja_norma_legal'}
                              label='Número de norma legal'
                              handleInput={handleInput}
                              />
                          </div>
                        </div>
                    </div>
                  </div>
                </div>

              </div>

              <button disabled={saving} onClick={()=>validarCampos()} className="btn btn-danger mt-3 me-3" type="button">
                {saving && (<span className="spinner-border spinner-border-sm me-1" aria-hidden="true"></span>)}
                <span role="status">Verificar</span>
              </button>

              {/* <button disabled={saving} className="btn btn-primary mt-3 me-3" type="submit">
                {saving && (<span className="spinner-border spinner-border-sm me-1" aria-hidden="true"></span>)}
                <span role="status">Aprobar</span>
              </button> */}
              { valido && (
                <button disabled={step===1} className="btn btn-primary mt-3" data-bs-target="#carouselExample" data-bs-slide="next" type="button">Siguiente Paso</button>
                )
              }

            </div>
            <div className='carousel-item'>
              <h5>Paso 2/2</h5>
              { valido && (
                <>
                Descargue el documento, fírmelo y adjúntelo firmado <br />
                <button onClick={() => generarDDJJObligado()} type="button" className="btn btn-primary mt-3" target='_blank'>Descargar Documento</button>
                <div className="mt-3 mb-3">
                  Una vez firmado, adjúntelo aquí
                  <input
                    placeholder="Adjunte el documento interactivo"
                    className="form-control"
                    onChange={handleFileChange}
                    accept='.pdf'
                    name="adjunto"
                    type="file"
                    id="adjunto" />
                </div>
                </>
                )
              }
              <hr className='mt-3 mb-3' />
              <button className="btn btn-danger mt-3 me-3" data-bs-target="#carouselExample" data-bs-slide="prev" type="button">Volver</button>

              <button disabled={saving} className="btn btn-primary mt-3" type="submit">
                {saving && (<span className="spinner-border spinner-border-sm me-1" aria-hidden="true"></span>)}
                <span role="status">Finalizar</span>
              </button>

            </div>
          </div>
        </form>

        </>
      )}
    </div>
  );
};

export default DeclaracionJuradaForm;